import { Suspense } from "react";

import { useIntl } from "react-intl";

import { CfLoader } from "@/shared/components/common/CfLoader/CfLoader";
import DynamicIntlProvider from "@/shared/components/DynamicIntlProvider/DynamicIntlProvider";
import { BaseContainer } from "@/shared/containers/BaseContainer/BaseContainer";
import { usePageTitle } from "@/shared/hooks/usePageTitle";
import { LANGUAGE_ID } from "@/shared/lang/lang.constants";
import Localization from "@/shared/services/Localization.service";

import { Login } from "./Login";

const LoginContent = (): React.ReactElement => {
  const intl = useIntl();
  usePageTitle(intl.formatMessage({ id: "Login.cleverfarm-login" }));

  return (
    <Suspense fallback={<CfLoader />}>
      <Login />
    </Suspense>
  );
};

const LoginWrapper = (): React.ReactElement => {
  const langId = Localization.getLang() as LANGUAGE_ID;

  return (
    <DynamicIntlProvider locale={langId}>
      <BaseContainer>
        <LoginContent />
      </BaseContainer>
    </DynamicIntlProvider>
  );
};

export { LoginWrapper };
